import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AamsGameDataState, AamsGameDataContextState, AamsGameDataSelector } from "@obg/gaming.aams-game-data";
import { Game } from "@obg/gaming.external";
import {
	AuthSelector,
	CoreState,
	Jurisdiction,
	JurisdictionSelector,
	ResponsibleGamingConfigService,
} from "@obg/ngx.core";
import { coerceBoolean } from "@obg/ngx.global.evo";

import { RegulatoryBarService } from "./regulatory-bar.service";

@Component({
	selector: "obg-regulatory-bar",
	templateUrl: "./regulatory-bar.container.html",
	styleUrls: ["./regulatory-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class RegulatoryBarContainer {
	@HostBinding("class.obg-regulatory-bar") readonly hostCssClass = true;

	@Input() @coerceBoolean() hideSessionTimer = false;
	@Input() @coerceBoolean() smallTimer = false;
	@Input() @coerceBoolean() desktopView = false;
	@Input() @coerceBoolean() mobileView = false;
	@Input() @coerceBoolean() inGame = false;
	@Input() @coerceBoolean() gameHistoryEnabled = false;
	@Input() aamsGameData: AamsGameDataContextState | undefined;
	@Input() game: Game | undefined;

	jurisdiction$ = this.store.select(JurisdictionSelector.get);
	isAuthenticated$ = this.store.select(AuthSelector.isAuthenticated);
	isRegulatoryBarEnabled$ = this.responsibleGamingConfigService.getRegulatoryBarEnabled$();
	isEnabledForLoggedOut$ = this.responsibleGamingConfigService.getRegulatoryBarEnabledForLoggedOut$();
	isAamsRegulatoryBarEnabled$ = this.regulatoryBarService.aamsRegulatoryBarEnabled$();
	shouldShowAamsSession$ = this.store.select(this.aamsGameDataSelector.isSessionDisplayed());
	shouldShowCodes: boolean | undefined;

	readonly ksaJurisdiction: Jurisdiction = Jurisdiction.Ksa;
	readonly aamsJurisdiction: Jurisdiction = Jurisdiction.Aams;
	readonly braJurisdiction: Jurisdiction = Jurisdiction.BRA;
	readonly cogaJurisdiction: Jurisdiction = Jurisdiction.COGA;

	constructor(
		private store: Store<CoreState & AamsGameDataState>,
		private responsibleGamingConfigService: ResponsibleGamingConfigService,
		private regulatoryBarService: RegulatoryBarService,
		private aamsGameDataSelector: AamsGameDataSelector
	) {}
}
